import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-title-extranet',
  templateUrl: './section-title.component-extranet.html',
  styleUrls: ['./section-title.component-extranet.scss']
})
export class SectionTitleExtranetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
